import { render, staticRenderFns } from "./FanSimpleTable.vue?vue&type=template&id=beb34802"
import script from "./FanSimpleTable.vue?vue&type=script&lang=js"
export * from "./FanSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports